import React from 'react'

import './stylesIT.css'

export default function IconTitle({ Icon, title, novidade = false }) {
  return (
    <div className='contain-title-div-infos'>
      {Icon && (
        <div className='icon-div-infos'>
          <Icon color='white' size={20} />
        </div>
      )}
      <h2>{title}</h2>
      {novidade && <h3 className='novidade-div-infos'>NOVIDADE</h3>}
    </div>
  )
}
